export const NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES = {
  normal: false,
  notNormal: false,
  declined: false,
  normalDetails: [],
  notNormalDetails: [],
  notes: "",
};

export const EYES_FORM_INITIAL_VALUES = {
  sections: {
    generalAppearanceEyes: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    lidsEyes: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    conjunctivaEyes: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    redReflexEyes: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type NewbornPostpartumPhysicalExamsEyesSections =
  keyof typeof EYES_FORM_INITIAL_VALUES.sections;
